/**
 * This file was auto-generated by openapi-typescript.
 * Do not make direct changes to the file.
 */

export interface paths {
  '/api/auth/register': {
    parameters: {
      query?: never
      header?: never
      path?: never
      cookie?: never
    }
    get?: never
    put?: never
    /**
     * Create user
     * @description Create a new user
     */
    post: operations['PostRegisterUser']
    delete?: never
    options?: never
    head?: never
    patch?: never
    trace?: never
  }
  '/api/auth/resend-activation': {
    parameters: {
      query?: never
      header?: never
      path?: never
      cookie?: never
    }
    get?: never
    put?: never
    /**
     * Resend user activation code
     * @description Resend user activation code
     */
    post: operations['PostResendUserActivation']
    delete?: never
    options?: never
    head?: never
    patch?: never
    trace?: never
  }
  '/api/auth/signin': {
    parameters: {
      query?: never
      header?: never
      path?: never
      cookie?: never
    }
    get?: never
    put?: never
    /**
     * Sign in user
     * @description Authenticate a user and create a session
     */
    post: operations['PostSigninUser']
    delete?: never
    options?: never
    head?: never
    patch?: never
    trace?: never
  }
  '/api/auth/verify': {
    parameters: {
      query?: never
      header?: never
      path?: never
      cookie?: never
    }
    get?: never
    put?: never
    /**
     * Verify user
     * @description Verify a user authentication
     */
    post: operations['PostVerifyUser']
    delete?: never
    options?: never
    head?: never
    patch?: never
    trace?: never
  }
  '/api/auth/refresh': {
    parameters: {
      query?: never
      header?: never
      path?: never
      cookie?: never
    }
    get?: never
    put?: never
    /**
     * Refresh user token
     * @description Refresh user token
     */
    post: operations['PostRefreshUserToken']
    delete?: never
    options?: never
    head?: never
    patch?: never
    trace?: never
  }
  '/api/buynow/transfer': {
    parameters: {
      query?: never
      header?: never
      path?: never
      cookie?: never
    }
    get?: never
    put?: never
    /**
     * Transfer a cart
     * @description Transfer a cart to external system
     */
    post: operations['PostTransferCart']
    delete?: never
    options?: never
    head?: never
    patch?: never
    trace?: never
  }
  '/api/buynow/mobiway': {
    parameters: {
      query?: never
      header?: never
      path?: never
      cookie?: never
    }
    get?: never
    put?: never
    /**
     * Create a buy now cart with a Mobiway POP
     * @description Create a buy now cart with a Mobiway POP device
     */
    post: operations['PostCreateMobiwayCart']
    delete?: never
    options?: never
    head?: never
    patch?: never
    trace?: never
  }
  '/api/qgraph': {
    parameters: {
      query?: never
      header?: never
      path?: never
      cookie?: never
    }
    /**
     * Get decision graph state
     * @description Get the current state of the decision graph based on navigation keys
     */
    get: operations['GetDecisionGraphState']
    put?: never
    post?: never
    delete?: never
    options?: never
    head?: never
    patch?: never
    trace?: never
  }
  '/api/metadata/phonecodes': {
    parameters: {
      query?: never
      header?: never
      path?: never
      cookie?: never
    }
    /**
     * Get country phone codes
     * @description Returns a list of country phone codes
     */
    get: operations['GetPhoneCodes']
    put?: never
    post?: never
    delete?: never
    options?: never
    head?: never
    patch?: never
    trace?: never
  }
  '/api/metadata/resellers': {
    parameters: {
      query?: never
      header?: never
      path?: never
      cookie?: never
    }
    /**
     * Get resellers for country user's in
     * @description Returns available resellers for the country provided in the mobiway-country header
     */
    get: operations['GetResellers']
    put?: never
    post?: never
    delete?: never
    options?: never
    head?: never
    patch?: never
    trace?: never
  }
  '/api/metadata/locales/{code}.json': {
    parameters: {
      query?: never
      header?: never
      path?: never
      cookie?: never
    }
    /**
     * Get locale translations
     * @description Returns the raw JSON translation file for the given locale code (e.g. fr, en)
     */
    get: operations['GetLocaleByCode']
    put?: never
    post?: never
    delete?: never
    options?: never
    head?: never
    patch?: never
    trace?: never
  }
  '/api/search/address': {
    parameters: {
      query?: never
      header?: never
      path?: never
      cookie?: never
    }
    /**
     * Get address suggestions
     * @description Get address suggestions
     */
    get: operations['GetAddressSuggestions']
    put?: never
    post?: never
    delete?: never
    options?: never
    head?: never
    patch?: never
    trace?: never
  }
}
export type webhooks = Record<string, never>
export interface components {
  schemas: {
    AddressSuggestion: {
      address: string
      /** Format: double */
      latitude: number
      /** Format: double */
      longitude: number
    }
    /**
     * @description Represents the audio language used by the device during cable-pulling operations.
     * @enum {string}
     */
    AudioLanguage: AudioLanguage
    AuthSessionDto: {
      /** Format: uuid */
      sessionId: string
    }
    /** @enum {string} */
    AvailableCountry: AvailableCountry
    /** @enum {string} */
    CableColor: CableColor
    /** @enum {string} */
    CableDiameter: CableDiameter
    CalculateCartCommand: {
      /** Format: int32 */
      surface: number
      /** Format: double */
      ceilingHeight: number
      /** Format: int32 */
      floorsNumber: number
      /** Format: int32 */
      roomsNumber: number
      /** Format: int32 */
      lightPointsNumber: number
      /** Format: int32 */
      outletsNumber: number
      /** Format: int32 */
      specificOutletsNumber: number
      heatingType: components['schemas']['CalculatorHeatingType']
    }
    /** @enum {string} */
    CalculatorHeatingType: CalculatorHeatingType
    CartDeviceReferenceResponse: {
      /** Format: uuid */
      id: string
      type: components['schemas']['DeviceType']
      imageUrl?: string | null
      /** Format: int32 */
      quantity: number
    }
    CartResponse: {
      spoolReferences: components['schemas']['CartSpoolReferenceResponse'][]
      deviceReferences: components['schemas']['CartDeviceReferenceResponse'][]
      carts: components['schemas']['CartRetailerResponse'][]
    }
    CartRetailerResponse: {
      /** Format: uuid */
      cartId: string
      reseller: components['schemas']['Reseller']
      canBeOrdered: boolean
    }
    CartSpoolReferenceResponse: {
      /** Format: uuid */
      id: string
      name: string
      imageUrl?: string | null
      internalRef: components['schemas']['SpoolInternalRef']
      /** Format: double */
      initialLength: number
      cableColor: components['schemas']['CableColor']
      cableDiameter: components['schemas']['CableDiameter']
      /** Format: int32 */
      quantity: number
    }
    /** @enum {string} */
    Civility: Civility
    /** @enum {string} */
    CompanySize: CompanySize
    CompanySpoolNominalQuantityDto: {
      /** Format: uuid */
      spoolReferenceId: string
      name: string
      imageUrl?: string | null
      /** Format: double */
      initialLength: number
      cableColor: components['schemas']['CableColor']
      cableDiameter: components['schemas']['CableDiameter']
      /** Format: int32 */
      quantity: number
    }
    CreateCartCommand: {
      spools: components['schemas']['CreateCartItem'][]
      devices: components['schemas']['CreateCartItem'][]
    }
    CreateCartItem: {
      /** Format: uuid */
      id: string
      /** Format: int32 */
      quantity: number
    }
    CreateCompanySpoolNominalQuantitiesCommand: {
      quantities: components['schemas']['CreateCompanySpoolNominalQuantitiesItem'][]
    }
    CreateCompanySpoolNominalQuantitiesItem: {
      /** Format: uuid */
      spoolReferenceId: string
      /** Format: int32 */
      quantity: number
    }
    CreateDeviceCommand: {
      externalId: string
      type: components['schemas']['DeviceType']
      manufacturerName: string
      modelNumber: string
      serialNumber: string
      firmwareVersion: string
      hardwareVersion: string
      audioLanguage: components['schemas']['AudioLanguage']
    }
    CreateDevicePullSessionsCommand: {
      /** Format: uuid */
      id: string
      pullSessions: components['schemas']['DevicePullSession'][]
    }
    CreateDeviceSnapshotCommand: {
      /** Format: uuid */
      deviceId: string
      slot1?: components['schemas']['CreateDeviceSnapshotSlot'] | null
      slot2?: components['schemas']['CreateDeviceSnapshotSlot'] | null
      slot3?: components['schemas']['CreateDeviceSnapshotSlot'] | null
    }
    CreateDeviceSnapshotSlot: {
      externalId: string
      /** Format: double */
      initialLength?: number | null
      /** Format: double */
      remainingLength: number
      cableColor?: components['schemas']['CableColor'] | null
      cableDiameter?: components['schemas']['CableDiameter'] | null
    }
    CreateFirmwareCommand: {
      type: components['schemas']['DeviceType']
      version: string
      file: components['schemas']['IFormFile']
      hardwareVersion: string
    }
    CreateSiteCommand: {
      name: string
      address?: string | null
      /** Format: double */
      latitude?: number | null
      /** Format: double */
      longitude?: number | null
      /** Format: date-time */
      startedOn: string
      description?: string | null
      isNew: boolean
      type: components['schemas']['SiteType']
      /** Format: int32 */
      surface: number
      /** Format: int32 */
      floorsNumber: number
      /** Format: int32 */
      roomsNumber: number
      heatingType: components['schemas']['HeatingType']
    }
    CreateSiteMemberCommand: {
      code: string
    }
    CreateSiteMemberResponse: {
      /** Format: uuid */
      siteId: string
    }
    CreateSparePartOrderCommand: {
      /** Format: uuid */
      sparePartId: string
      breakDescription: string
      image: components['schemas']['IFormFile']
      company: string
      address: string
      postalCode: string
      city: string
      phoneNumber: string
      mobilePhoneNumber?: string | null
      firstName: string
      lastName: string
    }
    CreateSpoolCommand: {
      externalId: string
      color: components['schemas']['CableColor']
      diameter: components['schemas']['CableDiameter']
      /** Format: double */
      initialLength: number
      /** Format: double */
      remainingLength: number
      scanSource: components['schemas']['SpoolScanSource']
    }
    CreateSpoolResponse: {
      alreadyInStock: boolean
      /** Format: uuid */
      id: string
      externalId: string
      name: string
      imageUrl?: string | null
      /** Format: double */
      initialLength: number
      cableColor: components['schemas']['CableColor']
      cableDiameter: components['schemas']['CableDiameter']
      /** Format: double */
      remainingLength: number
      currentDevice?: components['schemas']['SpoolDeviceDto'] | null
      /** Format: date-time */
      deletedOn?: string | null
      /** Format: date-time */
      createdOn: string
      /** Format: date-time */
      updatedOn: string
    }
    /** @description Represents the pulled length for a single UTC day. */
    DailyPulledLengthDto: {
      /**
       * Format: date
       * @description Gets or sets the UTC day on which the pull sessions started.
       */
      day: string
      /**
       * Format: double
       * @description Gets or sets the total pulled length for the day.
       */
      pulledLength: number
    }
    /** @description Represents the pull-session aggregation for a single day. */
    DailySessionsCountDto: {
      /**
       * Format: date
       * @description Day (UTC) for which the pull sessions are aggregated.
       */
      day: string
      /**
       * Format: int32
       * @description Number of pull sessions started on DateOnly DailySessionsCountDto.Day for the company.
       */
      sessionsCount: number
      /**
       * Format: duration
       * @description Cumulated duration of the pull sessions of DateOnly DailySessionsCountDto.Day (sum of EndedOn - StartedOn).
       */
      cumulatedDuration: string
    }
    /** @description Represents the spool-stock-addition aggregation for a single day. */
    DailyStockAdditionsDto: {
      /**
       * Format: date
       * @description Day (UTC) for which the stock additions are aggregated.
       */
      day: string
      /**
       * Format: int32
       * @description Number of spools added to the company stock on DateOnly DailyStockAdditionsDto.Day via a device
       *     (SpoolScanSource.Device).
       */
      fromDeviceCount: number
      /**
       * Format: int32
       * @description Number of spools added to the company stock on DateOnly DailyStockAdditionsDto.Day via a phone
       *     (SpoolScanSource.Phone).
       */
      fromPhoneCount: number
    }
    DayPullLengthBySpoolReference: {
      /** Format: date */
      day: string
      spoolReferences?: components['schemas']['PullLengthBySpoolReference'][]
    }
    DeviceDetailsDto: {
      /** Format: uuid */
      id: string
      externalId: string
      name: string
      type: components['schemas']['DeviceType']
      lastPosition?: components['schemas']['DeviceDetailsLocationDto'] | null
      firmwareVersion: string
      /** Format: date-time */
      firmwareVersionUpdatedOn?: string | null
      lastLiveSlot1?: components['schemas']['DeviceDetailsSnapshotDto'] | null
      lastLiveSlot2?: components['schemas']['DeviceDetailsSnapshotDto'] | null
      lastLiveSlot3?: components['schemas']['DeviceDetailsSnapshotDto'] | null
      /** Format: date-time */
      lastLiveUpdatedOn: string
      manufacturerName: string
      modelNumber: string
      serialNumber: string
      hardwareVersion: string
      /** Format: date-time */
      createdOn: string
      /** Format: date-time */
      updatedOn: string
      audioLanguage: components['schemas']['AudioLanguage']
      statistics?: components['schemas']['DeviceStatsDto']
    }
    DeviceDetailsLocationDto: {
      address?: string | null
      /** Format: double */
      latitude: number
      /** Format: double */
      longitude: number
      /** Format: date-time */
      updatedOn: string
    }
    DeviceDetailsSnapshotDto: {
      externalId: string
      /** Format: double */
      remainingLength: number
      spoolReference?: components['schemas']['DeviceDetailsSpoolReferenceDto'] | null
    }
    DeviceDetailsSpoolReferenceDto: {
      /** Format: uuid */
      id: string
      name: string
      imageUrl?: string | null
      /** Format: double */
      initialLength: number
      cableColor: components['schemas']['CableColor']
      cableDiameter: components['schemas']['CableDiameter']
    }
    DevicePullSession: {
      externalId: string
      /** Format: double */
      initialLength: number
      /** Format: double */
      remainingLength: number
      color: components['schemas']['CableColor']
      diameter: components['schemas']['CableDiameter']
      /** Format: int32 */
      sequenceId: number
      /** Format: date-time */
      firstSeenDate: string
      /** Format: date-time */
      lastSeenDate: string
      /** Format: double */
      unwindingDuration: number
    }
    DeviceStatsDto: {
      /** Format: double */
      totalLength: number
      lengthByReference?: components['schemas']['DeviceStatsPerReferenceDto'][]
    }
    DeviceStatsPerReferenceDto: {
      /** Format: uuid */
      id: string
      nameKey: string
      cableColor: components['schemas']['CableColor']
      cableDiameter: components['schemas']['CableDiameter']
      /** Format: double */
      totalLength: number
    }
    /** @enum {string} */
    DeviceType: DeviceType
    DownloadFirmwareByVersionResponse: {
      /** Format: byte */
      content: string
      fileName: string
    }
    ExceptionDetails: {
      message?: string | null
      errors?: components['schemas']['ValidationErrorDto'][] | null
      stackTrace?: string[] | null
      exceptionType?: string | null
      requestId?: string | null
    }
    FirmwareDetailsDto: {
      type: components['schemas']['DeviceType']
      version: string
      /** Format: date-time */
      createdOn: string
      hardwareVersion: string
    }
    GetAddressSuggestionsResponse: {
      suggestions: components['schemas']['AddressSuggestion'][]
    }
    /** @description Represents pulled-length aggregations for the connected user's company. */
    GetPulledLengthResponse: {
      /** @description Gets or sets pulled lengths grouped by the UTC day on which each pull session started. */
      dailyPulledLengths?: components['schemas']['DailyPulledLengthDto'][]
      /** @description Gets or sets pulled lengths grouped by spool reference. */
      spoolReferencePulledLengths?: components['schemas']['SpoolReferencePulledLengthDto'][]
      /**
       * Format: double
       * @description Gets or sets the pulled length across all included pull session items.
       */
      totalPulledLength: number
      /**
       * Format: double
       * @description Gets or sets the pulled length from included pull sessions assigned to a site.
       */
      sitePulledLength: number
    }
    GetScrapRecyclingResponse: {
      /** Format: double */
      totalLength: number
      /** Format: double */
      potentialValue: number
    }
    GetSitePerformanceByIdResponse: {
      /** Format: double */
      pulledLength: number
      /** Format: double */
      comparedAverageLength?: number | null
      /** Format: int32 */
      comparedSitesCount: number
      detailsPerDay?: components['schemas']['DayPullLengthBySpoolReference'][]
    }
    GetSitesResponse: {
      /** Format: uuid */
      id: string
      name: string
      type: components['schemas']['SiteType']
      /** Format: double */
      pulledDistance: number
      /** Format: date-time */
      lastActivityOn?: string | null
      /** Format: date-time */
      closedOn?: string | null
      /** Format: date-time */
      createdOn: string
    }
    GetSiteStatsByIdResponse: {
      /** Format: duration */
      pullDuration: string
      /** Format: double */
      pullLength: number
      cables: components['schemas']['StatisticsByCable'][]
    }
    GetSparePartsResponse: {
      /** Format: uuid */
      id: string
      name: string
      imageUrl?: string | null
      deviceType: components['schemas']['DeviceType']
    }
    GetSpoolsLifetimeResponse: {
      /** @description Average lifetime aggregation, one entry per spool reference having at least one end-of-life spool. */
      spoolsLifetimes?: components['schemas']['SpoolLifetimeDto'][]
    }
    GetUsedSpoolsResponse: {
      /**
       * Format: int32
       * @description Number of distinct company spools used at least once (non-zero pulled length on at least one pull session item).
       */
      totalUsedSpools: number
      /**
       * @description Number of distinct used spools per spool reference.
       *     Only references with at least one used spool are returned.
       */
      usedSpoolsByReference?: components['schemas']['UsedSpoolsByReferenceDto'][]
    }
    /** @enum {string} */
    HeatingType: HeatingType
    HelpContactDto: {
      email?: string | null
      phoneNumber?: string | null
    }
    /** Format: binary */
    IFormFile: string
    /** @enum {string} */
    Language: Language
    PackDetailsDto: {
      internalRef: components['schemas']['PackInternalRef']
      country: components['schemas']['AvailableCountry']
      spoolReferences: components['schemas']['PackSpoolReferenceDto'][]
      deviceReferences: components['schemas']['PackDeviceReferenceDto'][]
    }
    PackDeviceReferenceDto: {
      /** Format: uuid */
      id: string
      type: components['schemas']['DeviceType']
      name: string
      nexansId: string
      eanCode: string
      gtinCode: string
      imageUrl?: string | null
      /** Format: int32 */
      quantity: number
    }
    /** @enum {string} */
    PackInternalRef: PackInternalRef
    PackSpoolReferenceDto: {
      /** Format: uuid */
      id: string
      internalRef: components['schemas']['SpoolInternalRef']
      nexansId: string
      eanCode?: string | null
      gtinCode?: string | null
      name: string
      imageUrl?: string | null
      /** Format: double */
      initialLength: number
      cableColor: components['schemas']['CableColor']
      cableDiameter: components['schemas']['CableDiameter']
      /** Format: int32 */
      quantity: number
      countries?: components['schemas']['AvailableCountry'][]
    }
    PatchCurrentUserCommand: {
      fcmToken?: string | null
      companyName?: string | null
      companySize?: components['schemas']['CompanySize'] | null
      companyAddress?: string | null
      phoneNumber?: string | null
      civility?: components['schemas']['Civility'] | null
      lastName?: string | null
      firstName?: string | null
      preferredLanguage?: components['schemas']['Language'] | null
      hasConsentedMarketing?: boolean | null
      preferredStore?: components['schemas']['AvailableCountry'] | null
    }
    PatchDeviceCommand: {
      /** Format: uuid */
      id: string
      name?: string | null
      /** Format: double */
      latitude?: number | null
      /** Format: double */
      longitude?: number | null
      /** Format: double */
      altitude?: number | null
      firmwareVersion?: string | null
      audioLanguage?: components['schemas']['AudioLanguage'] | null
    }
    PatchPullSessionCommand: {
      /** Format: uuid */
      id: string
      /** Format: uuid */
      siteId?: string | null
      ignore?: boolean | null
    }
    PatchSpoolCommand: {
      /** Format: uuid */
      id: string
      /** Format: double */
      remainingLength: number
    }
    PhoneCodeDto: {
      country: string
      code: string
    }
    PullLengthBySpoolReference: {
      /** Format: uuid */
      spoolReferenceId: string
      name?: string | null
      cableColor?: components['schemas']['CableColor'] | null
      cableDiameter?: components['schemas']['CableDiameter'] | null
      /** Format: double */
      length: number
    }
    PullSessionDetailsDto: {
      /** Format: uuid */
      id: string
      /** Format: date-time */
      startedOn: string
      /** Format: date-time */
      endedOn: string
      /** Format: double */
      totalLength: number
      /** Format: uuid */
      deviceId: string
      spools: components['schemas']['PullSessionSpoolDto'][]
    }
    PullSessionDto: {
      /** Format: uuid */
      id: string
      /** Format: date-time */
      startedOn: string
      /** Format: date-time */
      endedOn: string
      /** Format: double */
      totalLength: number
      /** Format: uuid */
      deviceId: string
    }
    PullSessionSpoolDto: {
      /** Format: uuid */
      id: string
      externalId?: string | null
      name?: string | null
      imageUrl?: string | null
      /** Format: double */
      initialLength?: number | null
      cableColor?: components['schemas']['CableColor'] | null
      cableDiameter?: components['schemas']['CableDiameter'] | null
      /** Format: double */
      remainingLength?: number | null
      /** Format: date-time */
      deletedOn?: string | null
      /** Format: date-time */
      createdOn: string
      /** Format: date-time */
      updatedOn: string
      /** Format: double */
      pulledLength: number
    }
    RefillAlertResponse: {
      /** Format: uuid */
      id: string
      /** Format: date-time */
      expectedSendDate: string
    }
    RefreshUserTokenCommand: {
      refreshToken: string
    }
    RegisterUserCommand: {
      email: string
      companyName: string
      companySize: components['schemas']['CompanySize']
      companyAddress: string
      phoneNumber: string
      civility: components['schemas']['Civility']
      lastName: string
      firstName: string
      preferredLanguage: components['schemas']['Language']
      hasConsentedMarketing: boolean
      preferredStore?: components['schemas']['AvailableCountry'] | null
    }
    /** @enum {string} */
    Reseller: Reseller
    ResendUserActivationCommand: {
      /** Format: uuid */
      sessionId: string
    }
    /** @enum {string} */
    Role: Role
    ServicesAvailabilityDto: {
      cableLoop: boolean
      calculator: boolean
      easyProtect: boolean
      spareParts: boolean
    }
    SigninUserCommand: {
      email: string
    }
    SiteDetailsDto: {
      /** Format: uuid */
      id: string
      name: string
      address: string
      /** Format: double */
      longitude?: number | null
      /** Format: double */
      latitude?: number | null
      /** Format: date-time */
      startedOn: string
      /** Format: date-time */
      closedOn?: string | null
      /** Format: date-time */
      lastActivityOn?: string | null
      description?: string | null
      isNew: boolean
      type: components['schemas']['SiteType']
      /** Format: int32 */
      surface: number
      /** Format: int32 */
      floorsNumber: number
      /** Format: int32 */
      roomsNumber: number
      heatingType: components['schemas']['HeatingType']
      devices: components['schemas']['SiteDeviceDto'][]
      members: components['schemas']['SiteMemberDto'][]
    }
    SiteDeviceDto: {
      /** Format: uuid */
      id: string
      name: string
    }
    SiteInvitationDto: {
      code: string
    }
    SiteMemberDto: {
      /** Format: uuid */
      id: string
      firstName: string
      lastName: string
    }
    /** @enum {string} */
    SiteType: SiteType
    SpoolDetailsDto: {
      /** Format: uuid */
      id: string
      externalId: string
      name: string
      imageUrl?: string | null
      /** Format: double */
      initialLength: number
      cableColor: components['schemas']['CableColor']
      cableDiameter: components['schemas']['CableDiameter']
      /** Format: double */
      remainingLength: number
      currentDevice?: components['schemas']['SpoolDeviceDto'] | null
      /** Format: date-time */
      deletedOn?: string | null
      /** Format: date-time */
      createdOn: string
      /** Format: date-time */
      updatedOn: string
    }
    SpoolDeviceDto: {
      /** Format: uuid */
      id: string
      name: string
      /** Format: int32 */
      slot: number
    }
    /** @enum {string} */
    SpoolInternalRef: SpoolInternalRef
    /** @description Average lifetime aggregation for a spool reference (color/diameter/initial length combination). */
    SpoolLifetimeDto: {
      color: components['schemas']['CableColor']
      diameter: components['schemas']['CableDiameter']
      /**
       * Format: double
       * @description Initial length of the spool reference (see `SpoolReference.InitialLength`).
       */
      initialLength: number
      /**
       * Format: int32
       * @description Number of spools of this reference that reached end of life (RemainingLength dropped below 3 meters).
       */
      endOfLifeSpoolsCount: number
      /**
       * Format: duration
       * @description Average lifetime of the spools of this reference that reached end of life.
       *     For each spool, the lifetime is the difference between the StartedOn of its very first pull-session item
       *     and the EndedOn of the first pull-session item for which RemainingLength dropped below 3 meters.
       */
      averageLifetime: string
    }
    SpoolReferenceDto: {
      /** Format: uuid */
      id: string
      name: string
      imageUrl?: string | null
      /** Format: double */
      initialLength: number
      cableColor: components['schemas']['CableColor']
      cableDiameter: components['schemas']['CableDiameter']
      countries?: components['schemas']['AvailableCountry'][]
    }
    /** @description Represents the pulled length for a spool reference. */
    SpoolReferencePulledLengthDto: {
      /**
       * Format: uuid
       * @description Gets or sets the spool reference identifier.
       */
      id: string
      /** @description Gets or sets the spool reference name key. */
      name?: string
      color: components['schemas']['CableColor']
      diameter: components['schemas']['CableDiameter']
      /**
       * Format: double
       * @description Gets or sets the initial length of the spool reference.
       */
      initialLength: number
      /**
       * Format: double
       * @description Gets or sets the total pulled length for the spool reference.
       */
      pulledLength: number
    }
    /** @enum {string} */
    SpoolScanSource: SpoolScanSource
    StatisticsByCable: {
      name?: string | null
      cableColor?: components['schemas']['CableColor'] | null
      cableDiameter?: components['schemas']['CableDiameter'] | null
      /** Format: double */
      length: number
    }
    TransferCartCommand: {
      /** Format: uuid */
      retailerCartId: string
      items?: components['schemas']['TransferCartItem'][] | null
      reseller: components['schemas']['Reseller']
    }
    TransferCartItem: {
      /** Format: uuid */
      id: string
      /** Format: int32 */
      quantity: number
    }
    TransferCartResponse: {
      /** Format: uuid */
      retailerCartId: string
      isSuccess: boolean
      method: string
      actionUrl: string
      body?: {
        [key: string]: string
      } | null
      textPlain?: string | null
    }
    UpdateSiteCommand: {
      /** Format: uuid */
      id: string
      name: string
      address?: string | null
      /** Format: double */
      latitude?: number | null
      /** Format: double */
      longitude?: number | null
      /** Format: date-time */
      startedOn: string
      description?: string | null
      isNew: boolean
      type: components['schemas']['SiteType']
      /** Format: int32 */
      surface: number
      /** Format: int32 */
      floorsNumber: number
      /** Format: int32 */
      roomsNumber: number
      heatingType: components['schemas']['HeatingType']
    }
    /** @description Number of distinct used spools for a given spool reference, along with the reference characteristics. */
    UsedSpoolsByReferenceDto: {
      /** @description Name of the spool reference (see `SpoolReference.NameKey`). */
      name?: string
      cableColor: components['schemas']['CableColor']
      cableDiameter: components['schemas']['CableDiameter']
      /**
       * Format: double
       * @description Initial length of the spool reference (see `SpoolReference.InitialLength`).
       */
      initialLength: number
      /**
       * Format: int32
       * @description Number of distinct spools of this reference used at least once.
       */
      count: number
    }
    UserDetailsCompanyDto: {
      /** Format: uuid */
      id: string
      name: string
      size: components['schemas']['CompanySize']
      address: string
    }
    UserDetailsDto: {
      /** Format: uuid */
      id: string
      role: components['schemas']['Role']
      company: components['schemas']['UserDetailsCompanyDto']
      civility: components['schemas']['Civility']
      firstName: string
      lastName: string
      email: string
      phoneNumber: string
      preferredLanguage: components['schemas']['Language']
      hasConsentedMarketing: boolean
      preferredStore: components['schemas']['AvailableCountry']
    }
    UserTokenDto: {
      idToken: string
      accessToken: string
      refreshToken: string
      /** Format: int32 */
      expiresIn?: number | null
    }
    ValidationErrorDto: {
      errorCode: string
      comparisonValues?: unknown[] | null
      attemptedValue?: unknown
      propertyName?: string
    }
    VerifyUserCommand: {
      /** Format: uuid */
      sessionId: string
      code: string
    }
  }
  responses: never
  parameters: never
  requestBodies: never
  headers: never
  pathItems: never
}
export type $defs = Record<string, never>
export interface operations {
  PostRegisterUser: {
    parameters: {
      query?: never
      header?: {
        'Mobiway-Country'?: components['schemas']['AvailableCountry']
      }
      path?: never
      cookie?: never
    }
    requestBody: {
      content: {
        'application/json': components['schemas']['RegisterUserCommand']
      }
    }
    responses: {
      /** @description Created */
      201: {
        headers: {
          [name: string]: unknown
        }
        content: {
          'application/json': components['schemas']['AuthSessionDto']
        }
      }
    }
  }
  PostResendUserActivation: {
    parameters: {
      query?: never
      header?: never
      path?: never
      cookie?: never
    }
    requestBody: {
      content: {
        'application/json': components['schemas']['ResendUserActivationCommand']
      }
    }
    responses: {
      /** @description OK */
      200: {
        headers: {
          [name: string]: unknown
        }
        content: {
          'application/json': components['schemas']['AuthSessionDto']
        }
      }
    }
  }
  PostSigninUser: {
    parameters: {
      query?: never
      header?: never
      path?: never
      cookie?: never
    }
    requestBody: {
      content: {
        'application/json': components['schemas']['SigninUserCommand']
      }
    }
    responses: {
      /** @description OK */
      200: {
        headers: {
          [name: string]: unknown
        }
        content: {
          'application/json': components['schemas']['AuthSessionDto']
        }
      }
    }
  }
  PostVerifyUser: {
    parameters: {
      query?: never
      header?: never
      path?: never
      cookie?: never
    }
    requestBody: {
      content: {
        'application/json': components['schemas']['VerifyUserCommand']
      }
    }
    responses: {
      /** @description OK */
      200: {
        headers: {
          [name: string]: unknown
        }
        content: {
          'application/json': components['schemas']['UserTokenDto']
        }
      }
    }
  }
  PostRefreshUserToken: {
    parameters: {
      query?: never
      header?: never
      path?: never
      cookie?: never
    }
    requestBody: {
      content: {
        'application/json': components['schemas']['RefreshUserTokenCommand']
      }
    }
    responses: {
      /** @description OK */
      200: {
        headers: {
          [name: string]: unknown
        }
        content: {
          'application/json': components['schemas']['UserTokenDto']
        }
      }
    }
  }
  PostTransferCart: {
    parameters: {
      query?: never
      header?: never
      path?: never
      cookie?: never
    }
    requestBody: {
      content: {
        'application/json': components['schemas']['TransferCartCommand']
      }
    }
    responses: {
      /** @description OK */
      200: {
        headers: {
          [name: string]: unknown
        }
        content: {
          'application/json': components['schemas']['TransferCartResponse']
        }
      }
    }
  }
  PostCreateMobiwayCart: {
    parameters: {
      query?: never
      header?: never
      path?: never
      cookie?: never
    }
    requestBody?: never
    responses: {
      /** @description OK */
      200: {
        headers: {
          [name: string]: unknown
        }
        content: {
          'application/json': components['schemas']['CartResponse']
        }
      }
    }
  }
  GetDecisionGraphState: {
    parameters: {
      query: {
        k: number[]
      }
      header?: never
      path?: never
      cookie?: never
    }
    requestBody?: never
    responses: {
      /** @description No Content */
      204: {
        headers: {
          [name: string]: unknown
        }
        content?: never
      }
    }
  }
  GetPhoneCodes: {
    parameters: {
      query?: never
      header?: never
      path?: never
      cookie?: never
    }
    requestBody?: never
    responses: {
      /** @description OK */
      200: {
        headers: {
          [name: string]: unknown
        }
        content: {
          'application/json': components['schemas']['PhoneCodeDto'][]
        }
      }
    }
  }
  GetResellers: {
    parameters: {
      query?: never
      header?: {
        'Mobiway-Country'?: components['schemas']['AvailableCountry']
      }
      path?: never
      cookie?: never
    }
    requestBody?: never
    responses: {
      /** @description OK */
      200: {
        headers: {
          [name: string]: unknown
        }
        content: {
          'application/json': components['schemas']['Reseller'][]
        }
      }
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown
        }
        content: {
          'application/json': components['schemas']['ExceptionDetails']
        }
      }
    }
  }
  GetLocaleByCode: {
    parameters: {
      query?: never
      header?: never
      path: {
        code: string
      }
      cookie?: never
    }
    requestBody?: never
    responses: {
      /** @description OK */
      200: {
        headers: {
          [name: string]: unknown
        }
        content: {
          'application/json': string
        }
      }
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown
        }
        content?: never
      }
    }
  }
  GetAddressSuggestions: {
    parameters: {
      query: {
        query: string
        country?: string
      }
      header?: {
        'Mobiway-Country'?: string
      }
      path?: never
      cookie?: never
    }
    requestBody?: never
    responses: {
      /** @description OK */
      200: {
        headers: {
          [name: string]: unknown
        }
        content: {
          'application/json': components['schemas']['GetAddressSuggestionsResponse']
        }
      }
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown
        }
        content: {
          'application/json': components['schemas']['ExceptionDetails']
        }
      }
    }
  }
}
export enum AudioLanguage {
  Bip = 'Bip',
  French = 'French',
  English = 'English',
  German = 'German',
  Spanish = 'Spanish',
  Arabic = 'Arabic',
  Portuguese = 'Portuguese',
  Italian = 'Italian',
  Dutch = 'Dutch',
  Max = 'Max',
  Unknown = 'Unknown',
}
export enum AvailableCountry {
  FR = 'FR',
  CO = 'CO',
}
export enum CableColor {
  Unknown = 'Unknown',
  Blue = 'Blue',
  YellowGreen = 'YellowGreen',
  Red = 'Red',
  Black = 'Black',
  Purple = 'Purple',
  Orange = 'Orange',
  Yellow = 'Yellow',
  Green = 'Green',
  White = 'White',
  Gray = 'Gray',
  Brown = 'Brown',
}
export enum CableDiameter {
  Unknown = 'Unknown',
  Section1_5 = 'Section1_5',
  Section2_5 = 'Section2_5',
  Section12AWG = 'Section12AWG',
  Section14AWG = 'Section14AWG',
}
export enum CalculatorHeatingType {
  ElectricRadiator = 'ElectricRadiator',
  HeatPump = 'HeatPump',
  Boiler = 'Boiler',
}
export enum Civility {
  Mr = 'Mr',
  Mrs = 'Mrs',
}
export enum CompanySize {
  SelfEmployed = 'SelfEmployed',
  Micro = 'Micro',
  Small = 'Small',
  Medium = 'Medium',
  Large = 'Large',
}
export enum DeviceType {
  POP = 'POP',
  MOB = 'MOB',
}
export enum HeatingType {
  ElectricRadiator = 'ElectricRadiator',
  HeatPump = 'HeatPump',
  Boiler = 'Boiler',
  NoHeating = 'NoHeating',
}
export enum Language {
  FR = 'FR',
  EN = 'EN',
  ES = 'ES',
  AR = 'AR',
  PT = 'PT',
  IT = 'IT',
  DE = 'DE',
  NL = 'NL',
}
export enum PackInternalRef {
  Simple = 'Simple',
  StarterSimple = 'StarterSimple',
  StarterDouble = 'StarterDouble',
  Spools3 = 'Spools3',
  Spools9 = 'Spools9',
}
export enum Reseller {
  Rexel = 'Rexel',
  Sonepar = 'Sonepar',
  Tereva = 'Tereva',
}
export enum Role {
  User = 'User',
  Administrator = 'Administrator',
}
export enum SiteType {
  Residential = 'Residential',
  Working = 'Working',
  Public = 'Public',
  HighRise = 'HighRise',
  Mixed = 'Mixed',
}
export enum SpoolInternalRef {
  GreenYellow25L100 = 'GreenYellow25L100',
  Blue25L100 = 'Blue25L100',
  Red25L100 = 'Red25L100',
  GreenYellow15L100 = 'GreenYellow15L100',
  Blue15L100 = 'Blue15L100',
  Red15L100 = 'Red15L100',
  Purple15L100 = 'Purple15L100',
  Orange15L100 = 'Orange15L100',
  Black15L100 = 'Black15L100',
  White15L100 = 'White15L100',
  Gray15L100 = 'Gray15L100',
  Brown15L100 = 'Brown15L100',
  Green12AWGL100 = 'Green12AWGL100',
  Red12AWGL100 = 'Red12AWGL100',
  Black12AWGL100 = 'Black12AWGL100',
  White12AWGL100 = 'White12AWGL100',
  Blue12AWGL100 = 'Blue12AWGL100',
  Yellow12AWGL100 = 'Yellow12AWGL100',
  Green14AWGL100 = 'Green14AWGL100',
  Red14AWGL100 = 'Red14AWGL100',
  Black14AWGL100 = 'Black14AWGL100',
  White14AWGL100 = 'White14AWGL100',
  Blue14AWGL100 = 'Blue14AWGL100',
  Yellow14AWGL100 = 'Yellow14AWGL100',
  Blue25L150 = 'Blue25L150',
  Red15L150 = 'Red15L150',
}
export enum SpoolScanSource {
  Phone = 'Phone',
  Device = 'Device',
}
